import { useEffect } from 'react'

import { type MembersCategorizedEnrollments } from 'utils/web_api.schemas'

interface HomePageTrackingData {
  userId?: string;
  selectedPlanYear: number;
  planYears: number[];
  enrollments: MembersCategorizedEnrollments | undefined;
  showRenewalsBanner: boolean;
  showOnboardingBanner: boolean;
  canChangePlans: boolean;
  qmeEnabled: boolean;
  userIsInactive?: boolean;
  isLoading: boolean;
}

/**
 * Hook to track the homepage view event when the page loads
 */
export const useHomePageTracking = ({
  userId,
  selectedPlanYear,
  planYears,
  enrollments,
  showRenewalsBanner,
  showOnboardingBanner,
  canChangePlans,
  qmeEnabled,
  userIsInactive,
  isLoading,
}: HomePageTrackingData) => {
  useEffect(() => {
    if (!isLoading) {
      window.segment?.page('[EE] Homepage', {
        referrer_page: document.referrer,
        userId,
        plan_year: selectedPlanYear,
        plan_years_available: planYears.length,
        has_medical_enrollments: (enrollments?.medical_enrollments?.length ?? 0) > 0,
        has_dental_enrollments: (enrollments?.dental_enrollments?.length ?? 0) > 0,
        has_vision_enrollments: (enrollments?.vision_enrollments?.length ?? 0) > 0,
        show_renewals_banner: showRenewalsBanner,
        show_onboarding_banner: showOnboardingBanner,
        can_change_plans: canChangePlans,
        qme_enabled: qmeEnabled,
        user_is_inactive: userIsInactive,
      })
    }
  }, [
    isLoading,
    userId,
    selectedPlanYear,
    planYears.length,
    enrollments,
    showRenewalsBanner,
    showOnboardingBanner,
    canChangePlans,
    qmeEnabled,
    userIsInactive,
  ])
}
